import { Exclude, Expose } from "class-transformer";
import { IsInt, IsString } from "class-validator";

import { CustomerFeedbackForDriver } from "./CustomerFeedbackForDriver";

@Exclude()
export class CustomerFeedbackForDriversCompany extends CustomerFeedbackForDriver {
    @IsString()
    @Expose()
    public driverName: string;

    @IsInt()
    @Expose()
    public driverProfileImageUrl?: string;
}
